import React, { useCallback, useState } from 'react'
import { Button, TextBody, get } from '@ally/metronome-ui'
import styled from 'styled-components'
import { AccountDetails } from '../../types'
import { Dd } from './DlComponents/StyledDlElements'
import { pastBestRate } from '../../utils/pastBestRate'

interface AccountDetailsProps {
  account: AccountDetails
}
const StyledButton = styled(Button)`
  padding: 0px;
  margin: 0;
  border: 0;
  line-height: 1;
  margin-left: ${get.space('xxs')};
  @media print {
    display: none;
  }
`
const StyledTextBody = styled(TextBody)`
  line-height: 1;
`
export const InterestRateToggle: React.FC<AccountDetailsProps> = ({
  account,
}) => {
  const [showHide, setShowHide] = useState('Show')
  const [currentInterestRate, setCurrentInterestRate] = useState(
    account.interestRate.toFixed(2),
  )
  const {
    interestRate,
    interestRatePvtEncrypt,
    accountStatus,
    currentBalancePvtEncrypt,
  } = account

  const toggleInterestRate = useCallback(() => {
    if (showHide === 'Show') {
      setShowHide('Hide')
      setCurrentInterestRate(interestRatePvtEncrypt.toFixed(5))
    } else {
      setShowHide('Show')
      setCurrentInterestRate(interestRate.toFixed(2))
    }
  }, [interestRate, interestRatePvtEncrypt, showHide])

  return (
    <Dd>
      {pastBestRate(account) &&
      accountStatus !== 'Closed' &&
      currentBalancePvtEncrypt <= 0 ? (
        <TextBody
          tag="span"
          size="sm"
          aria-label="not applicable"
          data-testid="notApplicableDashes"
        >
          --
        </TextBody>
      ) : (
        <>
          <StyledTextBody
            aria-label={`showing the ${
              showHide === 'Show' ? 'abbreviated' : 'full'
            } interest rate`}
            tag="span"
            size="sm"
            data-testid="interestRate"
            aria-live="polite"
          >
            {currentInterestRate}%
          </StyledTextBody>
          {` `}
          <StyledButton
            text={showHide}
            variant="link"
            onClick={toggleInterestRate}
            data-testid="toggleInterestRate"
            ariaLabel={
              showHide === 'Show'
                ? 'Show full interest rate'
                : 'Show abbreviated interest rate'
            }
            withAllyTM={`interestRate-${showHide.toLowerCase()}`}
          />
        </>
      )}
    </Dd>
  )
}
